<template>
  <div class="dashboard-card-container">
    <vs-card 
      class="main-card-container mt-4" 
      v-for="(card, index) in value"
      :key="index"
    >
      <div slot="header">
        <img height="60" :src="require(`@/assets/images/${card.logoPath}`)" alt>
      </div>
      <div 
        class="card-sections"
        v-for="(section, index) in card.sections"
        :key="index"
      >
        <div class="card-sub-title vx-row">
          <div class="vx-col mt-4">
            <h5 class="section-name">{{ section.sectionName }}</h5>
          </div>
        </div>
        <div class="card-buttons vx-row">
          <div
            v-for="(report, index) in section.reports"
            class="vx-col"
            :class="[report.class, { 'm-0' : !report.reportName }]"
            :key="index"
          >
            <ReportCard
              :report="report"
              :reportOptions="reportOptions"
              :dynamicBinderOptions="dynamicBinderOptions"
              :loadingOptions="loadingOptions"
              :isDownloadDisabled="downloadDisabled(report)"
              :getOptions="getOptions"
              :isFieldDisabled="isFieldDisabled"
              @field-change="onFieldChange"
              @download="downloadReport"
            />
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import ReportCard from '@/components/Dashboard/ReportCard.vue'
import FieldDependencyMixin from '@/components/mixins/FieldDependencyMixin.js'
import ReportService from '@/services/ReportService.js'

export default {
  name: "DashboardCardContainer",
  components: {
    ReportCard,
  },
  mixins: [FieldDependencyMixin],
  props: {
    value: {
      type: Array,
      required: true, 
    },
  },
  data() {
    return {
      selected: null,
      reportOptions: [],
      loadingOptions: false,
      dynamicBinderOptions: {}, // Store dynamic binder options by reportType and coverholder
      reportService: null,
    };
  },
  methods: {
    getOptions(reportType, field) {
      return this.reportService.getOptions(
        reportType, 
        field, 
        this.reportOptions, 
        this.dynamicBinderOptions, 
        this.findReportByType
      );
    },

    async downloadReport(report) {
      const params = this.reportService.prepareDownloadParams(report);
      this.$emit('download', params);
    },
    async onFieldChange(report, changedField, selectedOption) {
      // Use Vue.set to ensure reactivity
      this.$set(changedField, 'selectedOption', selectedOption);
      
      // Force update to ensure the multiselect displays the selection
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      
      // Only clear dependent fields if the changed field has dependent fields
      if (this.hasDependentFields(report, changedField)) {
        this.clearDependentFields(report, changedField);
      }
      
      // If the changed field is a CoverholderList, and fetch new BinderOptions
      if (changedField.dropdownOptionsType === 'CoverholderList' && changedField.selectedOption) {
        await this.fetchBinderOptions(report.reportType, changedField.selectedOption.id);
      }
    },
    async fetchBinderOptions(reportType, coverholderId) {
      const key = `${reportType}_${coverholderId}`;
      const mappedOptions = await this.reportService.fetchBinderOptions(reportType, coverholderId);
      
      // Use Vue.set to ensure reactivity
      this.$set(this.dynamicBinderOptions, key, mappedOptions);
      
      // Use nextTick to ensure DOM updates after data change
      this.$nextTick(() => {
        // DOM updated
      });
    },
    async getReportTypeOptions() {
      this.reportOptions = await this.reportService.getReportTypeOptions('en');
    },
  },
  async created() {
    // Initialize the report service
    this.reportService = new ReportService(this.$api);
    
    this.loadingOptions = true;
    await this.getReportTypeOptions();
    this.loadingOptions = false;
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/custom/components/_variables';

  .dashboard-card-container {
    .vs-card--header {
      > div {
        display: flex;
      }
    }

    .main-card-container {
      > .vs-card {
        &--header {
          padding: 2rem 1.5rem 0;
        }

        &--content {
          padding: 0 2rem;

          .card-sections {
            .card-sub-title {
               > .vx-col {
                 padding: 0 0.5rem;

                .section-name {
                  font-size: 20px;
                  color: #8c8c8c;
                }
               }
            }
          }

          .card-buttons {
            > .vx-col {
              margin: 0.5rem 0 1rem 0;
              // min-width: 280px;
              padding: 0 0.5rem;

              &.large-field {
                .card-content {
                  .field {
                    &:not(:first-child) {
                      margin-left: 15px;
                    }
                  }
                }
              }
            }
          } 
        }
      }
    }
  }
</style>

